<template>
	<span class="back-arrow"></span>
</template>

<script>
export default {
	name: 'BackArrow',
};
</script>
